import(/* webpackMode: "eager" */ "D:\\CL_Educate_apps\\cl-verse\\app\\page.tsx");
